import React from "react";

import bobsled from "../../../img/welcome-modal/bobsled.svg";
import pie from "../../../img/welcome-modal/pie.svg";

const UserWelcomeModal = ({ hasPremiumAccount }) => (
    <React.Fragment>
        <img
            src={pie}
            alt="It's a german tradition to bring a homemade pie to welcome someone to a new community."
            width="200"
            height="150"
        />
        <h1>Welcome to the Community</h1>

        {hasPremiumAccount ? (
            <p className="subhead">
                Your <span className="plan-pro">NounPro</span> membership is
                ready
            </p>
        ) : (
            <p className="subhead">
                Your <span className="plan-basic">Membership</span> is ready
            </p>
        )}
    </React.Fragment>
);

const TeamWelcomeModal = ({ team }) => (
    <React.Fragment>
        <img
            src={bobsled}
            alt="“Individually, we are one drop. Together, we are an ocean.” – Ryunosuke Satoro"
            title="“Individually, we are one drop. Together, we are an ocean.” – Ryunosuke Satoro"
            width="200"
            height="150"
        />
        <h1>Welcome to the Team</h1>
        <p className="subhead">
            You are a <span className="plan-team">NounTeam</span> Member of{" "}
            <a
                title="See who else is on your team"
                href={`/${team.slug}/settings/seats/`}
            >
                {team.name}
            </a>
        </p>
        <ul>
            <li>
                {team.owner_name} manages your <br />
                team account
            </li>
            <li>
                Download icons without having to <br />
                credit the creator
            </li>
            <li>
                Organize and collaborate with <br />
                team kits
            </li>
        </ul>
    </React.Fragment>
);

const WelcomeModal = props => (
    <div id="welcome_screen">
        {props.team ? (
            <TeamWelcomeModal team={props.team} username={props.username} />
        ) : (
            <UserWelcomeModal hasPremiumAccount={props.hasPremiumAccount} />
        )}
        <button className="button ui_search" onClick={props.dismissModal}>
            <span>Start Searching</span>
        </button>
    </div>
);

export default WelcomeModal;
